import { SubmitFormRequest, SubmitFormResponse } from './types';
import { marketoApiBaseUrl } from '.';

/**
 * Upserts a lead and generates a "Fill out Form" activity which is associated back to program and/or campaign.
 * Required Permissions: Read-Write Lead
 */
export const submitForm = async (request: SubmitFormRequest): Promise<SubmitFormResponse> => {
  const response = await fetch(`${marketoApiBaseUrl}/submitForm`, {
    body: JSON.stringify(request),
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  if (!response.ok) {
    throw new SubmitFormError('An error occurred, please try again later.');
  }

  const parsedResponse = await response.json() as SubmitFormResponse;
  if (parsedResponse.errors?.length) {
    throw new SubmitFormError(parsedResponse.errors.map(error => error.message).join(', '));
  }

  return parsedResponse;
};

export class SubmitFormError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SubmitFormError';
  }
}
